import React, { useState, useEffect } from 'react'
import StorefrontTitle from "../shared/storefront-title.component";
import Translations from '../../services/translation.service';
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import UserIDImg from "../../assets/img/UserId.svg";
import hintImg from "../../assets/img/hint.svg";
import SharedPhone from "../shared/sharedFields/phone";
import BillPaymentService from "../../services/bill-payment.service";
import Helpers from '../../helpers/shared.helper';
import Storage from '../../services/storage.service';
import FirebaseAnalytics from '../../services/analytics.service';
import FieldValidity from '../../services/fieldValidity.service';

const subscriptions = [];
const BillPaymentForm = ({ props }) => {
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    const [skipOTP, setSkipOTP] = useState(false);
    const [activeTab, setActiveTab] = useState("Mobile");
    const [formValues, setFormValues] = useState({
        submitLoader: false,
        nextStep: false,
        hasUnpaidBills: false,
        phone: {
            phoneCode: Settings?.country,
            value: "",
            touched: false,
            valid: false,
            validation: {
                required: true,
                phoneNumber: true,
                minLength: true,
                minLengthValue: 7,
                maxLength: true,
                maxLengthValue: 15,
            }
        },
        maskedContactNumber: null,
        contactNumber: null,
        idNumber: {
            value: "",
            valid: false,
            touched: false
        },
        billCivilErrorCode: null
    });

    useEffect(() => {
        if(Storage.get("billFlow", true) === "Mobile") {
            setActiveTab("Mobile");
        } else {
            setActiveTab("CivilID");    
        }
    }, [])

    useEffect(() => {
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_landing',
            interaction_type: 'view',
            event_label: 'screen'
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        // const phoneMaxLength = Helpers.getPOValue("top_up_number_length", 10);
        const phoneMaxLength = Helpers.getPOValue("hbb_number_length", 15);
        const bizSkipOTP = Helpers.getPOValue("skip_otp_bill_pay_web", false);
        setSkipOTP(bizSkipOTP);
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                validation: {
                    ...prevState.phone.validation,
                    maxLengthValue: phoneMaxLength
                }
            },
            nextStep: false,
        }));
    }, [])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    const updateContactInput = (phoneObj) => {
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
            },
            nextStep: false,
        }));
    }

    const updateContactField = (phoneObj) => {
        Storage.clear("genericOTPError");
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
                valid: phoneObj.valid,
                touched: phoneObj.touched,
                error: phoneObj.error
            },
        }));
        if(phoneObj.valid && phoneObj.touched) {
            setFormValues(prevState => ({
                ...prevState,
                submitLoader: true,
            }));
            let countryCode = Helpers.getCountryCodePO() || "";
            let data = {
                number: phoneObj?.value?.length === 15 ? phoneObj?.value : `${countryCode}${phoneObj?.value?.replace(/^0+/, '')}`,
                process: "bill_payment"
            }
            Storage.set("genericOTPError", true, true);
            BillPaymentService.requestOTP(data)
            .then(response => {
                Storage.set("genericOTPError", true, true);
                if(response) {
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: true,
                        submitLoader: false,
                        maskedContactNumber: response?.data?.MaskContactNumber,
                        contactNumber: response?.data?.ContactNumber,
                        isHBB: response?.data?.IsHBB
                    }));
                    if(response?.data?.IsHBB) {
                        Storage.set("isHBB", response?.data?.IsHBB, true);
                    } else {
                        Storage.clear("isHBB");
                    }
                } else {
                    Storage.clear("isHBB");
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: false,
                        submitLoader: false,                    
                        phone: {
                            ...prevState.phone,
                            valid: false,
                            error: "failed"
                        },
                    }));
                }
            })
            .catch(error => {
                Storage.clear("isHBB");
                setFormValues(prevState => ({
                    ...prevState,
                    nextStep: false,
                    submitLoader: false,                    
                    phone: {
                        ...prevState.phone,
                        valid: false,
                        error: error?.response?.data?.code
                    },
                }));
            });
        }
    }

    const moveToOTPScreen = (tab) => {
        Storage.clear("billCivilError");
        if(tab === "Mobile") {
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_landing',
                interaction_type: 'click',
                event_label: 'next',
                is_valid_numer: formValues?.phone?.valid ?? ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            props.history.push({
                pathname: '/bill-payment/otp',
                state: { formValues: formValues }
            });
        } else if(tab === "CivilID"){
            Storage.set("billCivilError", true, true);
            setFormValues(prevState => ({
                ...prevState,
                submitLoader: true,
            }));
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_landing',
                interaction_type: 'click',
                event_label: 'view_my_bill',
                is_valid_numer: formValues?.idNumber?.valid ?? ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            BillPaymentService.getBillsViaCivilID(formValues?.idNumber?.value)
            .then(response => {
                Storage.set("billCivilError", true, true);
                if(response.data) {    
                    setFormValues(prevState => ({
                        ...prevState,
                        submitLoader: false,
                    }));
                    props.history.push({
                        pathname: '/bill-payment/check-link',
                        state: { hasUnpaidBills: response?.data?.hasUnpaidBills }
                    });
                } else {
                    setFormValues(prevState => ({
                        ...prevState,
                        submitLoader: false,
                    }));    
                }
            })
            .catch(err => {
                setFormValues(prevState => ({
                    ...prevState,
                    idNumber: {
                        ...prevState.idNumber,
                        valid: false
                    }, 
                    nextStep: false,
                    submitLoader: false,
                    billCivilErrorCode: err.response.data.code
                }));        
            });
        }
    }

    const skipOTPScreen = () => {
        props.history.push({
            pathname: '/bill-payment/bills',
            state: { formValues: formValues }
        });
    }

    const convertError = (error) => {
        if(activeTab === "Mobile") {
            let errorCode = Math.abs(error);
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_landing',
                interaction_type: 'view',
                event_label: 'error',
                error_code:  errorCode || ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            return errorCode ? `stm_bill_payment_phone_error_${errorCode}` : "stm_bill_payment_phone_error_general";
        } else if(activeTab === "CivilID"){
            let errorCode = Math.abs(error);
            const firebase_event_params = {
                event_category: 'bills',
                event_screen: 'bill_landing',
                interaction_type: 'view',
                event_label: 'error',
                error_code:  errorCode || ""
            }
            FirebaseAnalytics.commonFunction(firebase_event_params);
            return errorCode ? `stm_bill_payment_civil_error_${errorCode}` : "stm_bill_payment_civil_error_general";
        } 
    }

    const updateIdNumber = (event) => {
        if (event.target) {
            const { name, value } = event.target;
            if (Helpers.isValidIDNumberSimple(event.target.value)) {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: true,
                        touched: true
                    }
                }));
            } else {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: false,
                        touched: true
                    },
                    nextStep: false
                }));
            }
        }
    }

    const validateCivilID = (e) => {
        if(formValues.idNumber.valid && formValues.idNumber.touched) {
            setFormValues(prevState => ({
                ...prevState,
                nextStep: true,
            }))
        }
    };

    return (
        <>
            <div className="generic-form-container generic-bill-payment-form-container">
                <StorefrontTitle
                    title={translationKeys["stm_quick_bill_payment_heading"] || "Quick and easy bill payments"}
                    desc={translationKeys["stm_bill_payment_method_desc"] || "Choose a method to view your bill"}
                />
                <div className="bill-payment-methods-container">
                    <div className="generic-tabs-button">
                        <div 
                            className={activeTab === "Mobile" && "tab-active"} 
                            onClick={() => {
                                setActiveTab("Mobile");
                                setFormValues(prevState => ({
                                    ...prevState,
                                    nextStep: false,
                                }))
                            }}
                        >
                            {translationKeys["stm_use_mob_num"] || "Use Mobile Number"}
                        </div>
                        <div 
                            className={activeTab === "CivilID" && "tab-active"} 
                            onClick={() => {
                                setActiveTab("CivilID")
                                setFormValues(prevState => ({
                                    ...prevState,
                                    nextStep: false,
                                }))
                            }}
                        >
                            {translationKeys["stm_use_iqama_saudi"] || "Use Iqama/Saudi ID"}
                        </div>
                    </div>
                    <div className="field-section">
                        {activeTab === "Mobile" ?
                        <div className="field-container">
                            <label>{translationKeys["stm_bill_payment_enter_number_vnet_postpaid"] || "Mobile number or  data number"}</label>
                                <SharedPhone 
                                    name="phone"
                                    id="phone"
                                    classname="storefront-phone-field"
                                    phone={formValues?.phone}
                                    updateContactField={updateContactField}
                                    updateContactInput={(e) => updateContactInput(e)}
                                    placeholder={translationKeys["stm_bill_payment_phone_placeholder_hbb"]}
                                    HBB={true}
                                />
                            {formValues.phone.error && !formValues.phone.valid ? <span className="error-msg">{translationKeys[convertError(formValues.phone.error)]}</span> : ""}
                        </div>
                        :
                        <div className="field-container">
                            <label>{translationKeys["stm_bill_payment_enter_number_civil_id"] || "Enter Saudi ID or Iqama ID"}</label>
                            <div className="field-with-icon">
                                <input
                                    className={
                                        "storefront-search-input " +
                                        (!formValues.idNumber.touched || (formValues.idNumber.touched && formValues.idNumber.valid)
                                            ? "valid"
                                            : "invalid") +
                                        (formValues.idNumber.value ? " filled" : "")
                                    }
                                    autoComplete="off"
                                    type="text"
                                    name="idNumber"
                                    id="idNumber"
                                    require="true"
                                    value={formValues.idNumber.value}
                                    onChange={(e) => {
                                        if (FieldValidity.numberOnly(e)) {
                                            updateIdNumber(e)
                                        }
                                    }}
                                    onBlur={(e) => validateCivilID(e)}
                                    placeholder={Translations.keys["stm_sim_postpaid_enter_id_number"] || "Enter ID number"}
                                />
                                <img src={UserIDImg} className="imgLeft" alt=""/>
                            </div>
                            {formValues.idNumber.touched && !formValues.idNumber.valid ? <span className="error-msg">{translationKeys[convertError(formValues.billCivilErrorCode)]}</span> : ""}
                            <div className="hint-section">
                                <img src={hintImg} alt="Message" />
                                <p>{Translations.keys["stm_enter_10_digit_id"] || "You will receive an SMS on the number associated with this ID number"}</p>
                            </div>
                        </div>
                        }
                    </div>
                    {formValues.submitLoader ?
                        <SpinnerTimeLoader /> 
                        :
                        <button
                            className={"common-button"}
                            disabled={
                                (!formValues.phone.valid || !formValues.idNumber.valid) &&
                                !formValues.nextStep
                            }
                            onClick={() => {
                                if(skipOTP) {
                                    skipOTPScreen();
                                } else {
                                    moveToOTPScreen(activeTab);
                                }
                            }}
                        >
                            {translationKeys["stm_bill_payment_view_my_bill"] || "View my bill"} 
                        </button>
                    }
                </div>
            </div>
        </>
    );
};

export default BillPaymentForm;